module.exports = __webpack_public_path__ + "img/img_mini_contact_form.4dda15a.jpg";